@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/greys';
@forward '@raspberrypifoundation/design-system-core/scss/properties/border';
@forward '../../global/styles';

:host {
  --nav-background: var(--rpf-white);
  --border-color: var(--rpf-grey-50);
  --box-shadow-color: rgba(0 0 0 / 8%);
  --dropdown-active-background-color: var(--rpf-grey-100);
  --dropdown-hover-background-color: var(--rpf-grey-50);
  --menu-text-color: var(--text-color);
}

:host([theme='clear']) {
  --dropdown-active-background-color: var(--transparent-black-200);
  --dropdown-hover-background-color: var(--transparent-black-100);
  --menu-text-color: var(--rpf-text-primary);
}

:host([theme='dark']) {
  --dropdown-active-background-color: var(--rpf-grey-600);
  --dropdown-hover-background-color: var(--rpf-grey-700);
  --nav-background: var(--rpf-grey-850);
  --text-color: var(--rpf-text-primary-darkmode);
  --border-color: var(--rpf-grey-900);
  --box-shadow-color: var(--rpf-grey-900);
  --menu-text-color: var(--text-color);
}

.rpf-dropdown {
  padding-inline: var(--space-1);

  @container (min-width: 22.5rem) {
    position: relative;
  }

  &__button {
    align-items: center;
    background-color: transparent;
    block-size: 2rem;
    border: none;
    border-radius: var(--border-radius);
    box-sizing: border-box;
    color: var(--text-color);
    cursor: pointer;
    display: flex;
    inline-size: 2rem;
    justify-content: center;
    padding: var(--space-1);
    position: relative;

    &::after {
      // WCGAG guidance states that button targets should be a mimiimum of 44px x 44px;
      // This extends the hitbox vertically without affecting visual styles
      content: '';
      inset: -0.375rem;
      position: absolute;
    }

    @container (min-width: 22.5rem) {
      inline-size: inherit;

      &::after {
        // WCGAG guidance states that button targets should be a mimiimum of 44px x 44px;
        // This extends the hitbox vertically without affecting visual styles

        content: '';
        inset-block: -0.375rem;
        inset-inline: 0;
        position: absolute;
      }
    }

    &:hover {
      background-color: var(--dropdown-hover-background-color);
    }

    &:focus-visible {
      background-color: transparent;
      outline: var(--border-width-md) solid var(--focus-border-color);
    }

    &:active {
      background-color: var(--dropdown-active-background-color);
    }

    &--selected {
      background-color: var(--dropdown-active-background-color);
    }
  }

  &__menu {
    background-color: var(--nav-background);
    border: var(--border-width-sm) solid var(--border-color);
    border-radius: var(--border-radius);
    box-shadow: 0 0 var(--space-1) 0 var(--box-shadow-color);
    box-sizing: content-box;
    color: var(--menu-text-color);
    display: none;
    inset-block-start: calc(100% + var(--space-1));
    inset-inline: 0;
    margin-inline: var(--space-1);
    max-block-size: min(370px, 50vh);
    overflow: hidden;
    position: absolute;

    &--visible {
      display: flex;
    }

    @container (min-width: 22.5rem) {
      inline-size: max-content;
      inset-block-start: calc(100% + var(--space-2));
      inset-inline-end: unset;
      margin-inline: unset;
      max-inline-size: 15rem;
      min-inline-size: 9.375rem;

      &--align-end {
        inset-inline-end: 0;
      }

      &--align-start {
        inset-inline-start: 50%;
        transform: translateX(-67%);
      }

      &--align-center {
        inset-inline-start: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
